import { Cookies } from '../constants/cookies';

export const getCookieValue = (cookieName: string) => {
  return document
    ? document.cookie
      .split('; ')
      .find(
        (row: string) => row.startsWith(`${cookieName}=`)
      )?.split('=')[1]
    : undefined;
  }

export const getFacebookCampaignCookies = (document: Document) => {
  const fbp = Cookies.FACEBOOK_PIXEL;
  const fbc = Cookies.FACEBOOK_CLICK_ID;
  const params = []
  const fbpValue = getCookieValue(fbp);
  const fbcValue = getCookieValue(fbc);

  fbc && fbcValue ? params.push(`facebook_click_id=${fbcValue}`) : null;
  fbp && fbpValue ? params.push(`facebook_browser_id=${fbpValue}`) : null;
    
  return params;
};